import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorNavigationService {

   private lastFailedUrl: string | null = null;
  private retryCount = 0;

  setFailedUrl(url: string): void {
    this.lastFailedUrl = url;
  }

  getFailedUrl(): string | null {
    return this.lastFailedUrl;
  }

  incrementRetryCount(): number {
    this.retryCount++;
    return this.retryCount;
  }

  getRetryCount(): number {
    return this.retryCount;
  }

  resetRetryCount(): void {
    this.retryCount = 0;
  }

  clear(): void {
    this.lastFailedUrl = null;
    this.retryCount = 0;
  }
}